import * as Yup from 'yup';
import { sharedSchema } from '../shared/sharedSchema';

export const schema = Yup.object().shape({
    gender: Yup.string().nullable().required('Pole wymagane'),
    isPregnat: Yup.string()
        .nullable()
        .when('gender', (val, _schema) => {
            if (val === 'woman') {
                return _schema.required('Pole wymagane').nullable();
            }
            return _schema;
        }),
    importantInformation: Yup.string().required('Pole wymagane'),
    genericReferralTextField: Yup.string().required('Pole wymagane'),
    ...sharedSchema,
});
